import { useDispatch, useSelector } from 'react-redux';
import { updateGeo } from 'state/actions/geo.actions';
import useCountryParam from './useCountryParam';
import { useEffect } from 'react';
import { useFetchCountries } from './api';

function useCurrentCountry() {
    const dispatch = useDispatch();
    const geo = useSelector(({ geo }) => geo);
    const countriesQuery = useFetchCountries();
    const { currentCountryParam } = useCountryParam();
    const currentCountry = countriesQuery.data
        ? countriesQuery.data.find(
              ({ text_id }) => text_id === currentCountryParam,
          )
        : null;
    // update the reducer until it's no longer needed
    useEffect(() => {
        if (currentCountry?.id !== geo?.id) {
            dispatch(updateGeo(currentCountry));
        }
    }, [currentCountry, geo]);
    return currentCountry;
}

export default useCurrentCountry;
